document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".product_image_list_3");

  images.forEach((img) => {
    const wrapper = img.closest(".main_product_warp");
    const placeholder = wrapper
      ? wrapper.querySelector(".image-placeholder")
      : null;

    // Function to show image + hide loader
    const showImage = () => {
      img.style.opacity = "1";
      if (placeholder) placeholder.style.display = "none";
    };

    // If image already loaded (cached), handle immediately
    if (img.complete) {
      showImage();
    } else {
      // Normal case: wait for load or error
      img.addEventListener("load", showImage);
      img.addEventListener("error", showImage); // hide loader even if broken
    }
  });
});

/* Swiper Slider packaging */
document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".pdp_packaging_block", {
    loop: true,
    pagination: {
      el: ".pdp_packaging-pagination",
      clickable: true,
    },
  });
});
/* Swiper Slider packaging End */

setTimeout(() => {
  const pdpRead = document.querySelector(".pdpRead");
  const pdpReadContent = pdpRead?.querySelector(".pdpReadContent");
  const pdpReadBtn = pdpRead?.querySelector(".pdpReadBtn");

  if (pdpReadContent && pdpReadBtn) {
    pdpReadBtn.addEventListener("click", () => {
      pdpReadContent.classList.toggle("expanded");

      if (pdpReadContent.classList.contains("expanded")) {
        pdpReadBtn.textContent = "Read Less";
      } else {
        pdpReadBtn.textContent = "Read More";
      }
    });
  } else {
  }
  document.querySelector(".pdpReadBtn").addEventListener("click", function () {
    const content = document.querySelector(".pdpReadContent");
    if (content.style.maxHeight) {
      // Collapse
      content.style.maxHeight = null;
    } else {
      // Expand
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}, 100);

// Start size chart JS
document.addEventListener("DOMContentLoaded", function () {
  let scrollY = 0;

  function closeSizeChart() {
    size_guide_modal.classList.remove("chart_active");
    size_chart_mask.classList.remove("mask_active");

    // Restore body scroll
    document.body.classList.remove("mds_chart_active");
    document.documentElement.classList.remove("no-scroll");

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.overflow = "";
    document.body.style.height = "";

    window.scrollTo(0, scrollY);
  }

  var size_guide_button = document.querySelector(".size_cart_text");
  var size_guide_modal = document.querySelector(".mds_chart_modal");
  var size_chart_mask = document.querySelector(".pdp-size-chart_mask");
  var size_guide_close_button = document.querySelector(
    ".mds_chart_modal-btn-close",
  );

  if (size_guide_button) {
    size_guide_button.addEventListener("click", function () {
      size_guide_modal.classList.add("chart_active");
      size_chart_mask.classList.add("mask_active");

      // Scroll lock for iOS Safari
      scrollY = window.scrollY || window.pageYOffset;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";

      document.body.classList.add("mds_chart_active");
      document.documentElement.classList.add("no-scroll");
    });
  }

  if (size_guide_close_button) {
    size_guide_close_button.addEventListener("click", function () {
      size_guide_modal.classList.remove("chart_active");
      size_chart_mask.classList.remove("mask_active");

      // Scroll unlock
      document.body.classList.remove("mds_chart_active");
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.documentElement.classList.remove("no-scroll");

      window.scrollTo(0, scrollY);
    });
  }

  if (size_guide_modal) {
    size_guide_modal.addEventListener("click", function (e) {
      // Only close when clicking outside the dialog
      if (e.target === size_guide_modal) {
        closeSizeChart();
      }
    });
  }

  var size_chart_tabs = document.querySelectorAll(".tab-pane.mds_tab-pane");
  var size_chart_size_chart_tabs_btns = document.querySelectorAll(
    "span.pdp-size-chart__tab-selected-links.tab-btn",
  );

  if (size_chart_size_chart_tabs_btns) {
    size_chart_size_chart_tabs_btns.forEach(function (btn, index) {
      btn.addEventListener("click", function () {
        // Remove active class from all size_chart_tabs and buttons
        size_chart_tabs.forEach(function (tab) {
          tab.classList.remove("active");
        });
        size_chart_size_chart_tabs_btns.forEach(function (tabBtn) {
          tabBtn.classList.remove("active");
        });

        // Add active class to the clicked button and tab
        btn.classList.add("active");
        size_chart_tabs[index].classList.add("active");
      });
    });
  }

  if (document.querySelectorAll(".pdp-size-chart__size-buttons-list li")) {
    document
      .querySelectorAll(".pdp-size-chart__size-buttons-list li")
      .forEach((item) => {
        item.addEventListener("click", (event) => {
          if (item.classList.contains("disabled")) return;

          document
            .querySelectorAll(".pdp-size-chart__size-buttons-list li")
            .forEach((li) => {
              document.getElementById("inch-button").classList.remove("active");
              li.classList.remove("active");
              convertModelMeasurements();
            });

          document.getElementById("cm-button").classList.add("active");
          item.classList.add("active");
        });
      });
  }

  if (document.getElementById("inch-button")) {
    document
      .getElementById("inch-button")
      .addEventListener("click", function () {
        if (!this.classList.contains("active")) {
          document.getElementById("cm-button").classList.remove("active");
          this.classList.add("active");
          convertMeasurements("inch");
          // convertModelMeasurements('inch');
        }
      });
  }

  if (document.getElementById("cm-button")) {
    document.getElementById("cm-button").addEventListener("click", function () {
      if (!this.classList.contains("active")) {
        document.getElementById("inch-button").classList.remove("active");
        this.classList.add("active");
        convertMeasurements("cm");
        // convertModelMeasurements('cm');
      }
    });
  }

  function convertModelMeasurements() {
    var element = document.querySelector(
      ".pdp-size-chart__model-measurements.mds_chart_col16.model_measurements",
    );

    var descriptionElement = document.querySelector(
      ".pdp-size-chart__model-description.mds_chart_col16",
    );
    var newDescriptionContent = descriptionElement.getAttribute("data-heading");

    descriptionElement.innerHTML = newDescriptionContent;
  }

  function convertMeasurements(unit) {
    const measurementElements = document.querySelectorAll(".measurement");
    const measurementElementsinfeet =
      document.querySelector(".measurementinfeet");
    const measurementElementsinfeet2 = document.querySelector(
      ".measurementinfeet2",
    );
    const feetAndInches = "6ft ";
    const feetAndInches2 = '5ft 9"';
    const feet = parseInt(feetAndInches);
    const feet2 = parseInt(feetAndInches2);
    const inches2 = parseFloat(
      feetAndInches2.substring(
        feetAndInches2.indexOf(" ") + 1,
        feetAndInches2.indexOf('"'),
      ),
    );
    const inches = parseFloat(
      feetAndInches.substring(
        feetAndInches.indexOf(" ") + 1,
        feetAndInches.indexOf('"'),
      ),
    );
    measurementElements.forEach((element) => {
      const value = parseFloat(element.textContent);
      if (unit === "inch") {
        element.textContent = (value / 2.54).toFixed(2) + '"';
        if (measurementElementsinfeet) {
          measurementElementsinfeet.textContent = feet + "ft ";
        }
        if (measurementElementsinfeet2) {
          measurementElementsinfeet2.textContent =
            feet2 + "ft " + inches2 + '"';
        }
      } else if (unit === "cm") {
        element.textContent = (value * 2.54).toFixed(1) + " cm";
        const totalInches2 = feet2 * 12 + inches2;
        const totalInches = feet * 12 + inches;
        if (measurementElementsinfeet) {
          measurementElementsinfeet.textContent = "185cm";
        }
        if (measurementElementsinfeet2) {
          measurementElementsinfeet2.textContent = "176cm";
        }
      }
    });
  }

  if (document.getElementById("size-chart-measurement-input")) {
    document
      .getElementById("size-chart-measurement-input")
      .addEventListener("change", function () {
        var selectedValue = this.value;
        var measurementsTab = document.querySelector(
          '.tab-pane.mds_tab-pane[data-tab="measurements"]',
        );
        var conversionTab = document.querySelector(
          '.tab-pane.mds_tab-pane[data-tab="conversion"]',
        );

        if (selectedValue === "measurements") {
          measurementsTab.classList.add("active");
          conversionTab.classList.remove("active");
        } else if (selectedValue === "conversion") {
          conversionTab.classList.add("active");
          measurementsTab.classList.remove("active");
        }
      });
  }
});
// End size chart JS

//start variants size- js

if (document.querySelectorAll(".size_variants_grid_wrap ul li")) {
  // Get references to the buttons and placeholder
  var selectSizeButton = document.getElementById("select-size-button");
  var addToCartButton = document.querySelector(".addtocart-button-jacket-pant");
  var floatbtn = document.querySelector(".floating_atc_button");
  var bisTriggerPlaceholder = document.querySelector(
    ".join_the_waiat_list_variant_disabled",
  );

  // Variable to store the selected variant's ID
  var selectedVariantId = null;

  // Add click event listener to each size variant
  document.querySelectorAll(".size_variants_grid_wrap ul li").forEach((li) => {
    li.addEventListener("click", function () {
      // Remove the class 'custom-active' from all list items
      document
        .querySelectorAll(".size_variants_grid_wrap ul li")
        .forEach((item) => {
          item.classList.remove("custom-active");
        });

      // Add the class 'custom-active' to the clicked list item
      this.classList.add("custom-active");

      // Get the selected variant's ID
      selectedVariantId =
        this.querySelector(".size_variants_box").getAttribute("data-idvalue");

      // Update the button's data-id with the selected variant's ID
      if (addToCartButton) {
        addToCartButton.setAttribute("data-id", selectedVariantId);
      }

      if (floatbtn) {
        floatbtn.setAttribute("data-id", selectedVariantId);
      }

      // Toggle buttons based on the presence of the 'disabled' attribute
      if (this.classList.contains("disabled")) {
        if (selectSizeButton) {
          selectSizeButton.style.display = "none";
        }

        if (addToCartButton) {
          addToCartButton.style.display = "none";
        }

        if (bisTriggerPlaceholder) {
          bisTriggerPlaceholder.style.display = "flex";
        }

        // Sticky button
        if (floatbtn) {
          floatbtn.dataset.id = selectedVariantId;
          floatbtn.id = "sticky_BIS_trigger";
          floatbtn.removeAttribute("data-url");
          const text = floatbtn.querySelector(".custom-atc");
          if (text) {
            text.textContent = "JOIN THE WAITLIST";
          }
        }
      } else {
        if (selectSizeButton) {
          selectSizeButton.style.display = "none";
        }
        if (addToCartButton) {
          addToCartButton.style.display = "flex";
        }
        if (bisTriggerPlaceholder) {
          bisTriggerPlaceholder.style.display = "none";
        }
        // Sticky button
        if (floatbtn) {
          floatbtn.dataset.id = selectedVariantId;
          floatbtn.removeAttribute("id");
          const text = floatbtn.querySelector(".custom-atc");
          if (text) {
            text.textContent = "ADD TO BAG";
          }
        }
      }
      // Refresh sticky button after DOM updates
      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 50);
    });
  });
}

if (document.getElementById("select-size-button")) {
  document
    .getElementById("select-size-button")
    .addEventListener("click", function () {
      var btnStatText = document.getElementById("select-size-button");
      // Add the animation class
      btnStatText.classList.add("animate-status");
      // Remove the animation class after 0.3 seconds
      setTimeout(function () {
        btnStatText.classList.remove("animate-status");
      }, 300);
    });
}
//end variants size- js

// Fancybox Config
$('[data-fancybox="gallery"]').fancybox({
  buttons: ["close"],
  loop: false,
  clickContent: false,
  btnTpl: {
    smallBtn:
      '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>',
    close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
      '<path d="M13.4115 15.2153L8 9.8038L2.58847 15.2153L0.784624 13.4115L6.19616 7.99995L0.784625 2.58842L2.58847 0.784578L8 6.19611L13.4115 0.784578L15.2154 2.58842L9.80384 7.99995L15.2154 13.4115L13.4115 15.2153Z" fill="black"/>' +
      "</svg>" +
      "</button>",
    arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">' +
      '<path d="M6.25247 11.8182L7.63635 10.4509L3.1412 5.99999L7.63635 1.54908L6.25247 0.181811L0.363625 5.99999L6.25247 11.8182Z" fill="black"/>' +
      "</svg>" +
      "</button>",

    arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">' +
      '<path d="M1.74753 0.181824L0.363647 1.5491L4.8588 6.00001L0.363647 10.4509L1.74753 11.8182L7.63637 6.00001L1.74753 0.181824Z" fill="black"/>' +
      "</svg>" +
      "</button>",
  },
});

// Product page scroll slider
// Get the product slider container
const productSliderContainer = document.querySelector(".product__media-list");

// Get the track element
const trackElement = document.querySelector(".mds-mini-slider__track");

// Get the knob element
const knobElement = document.querySelector(".mds-mini-slider__knob");

// iOS momentum scroll fires scroll events faster than paint; without rAF
// throttling + a compositor-friendly transform the knob visibly jitters.
const isIOSDevice =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
if (isIOSDevice) {
  document.documentElement.classList.add("is-ios");
}

let knobRafId = null;

// Function to update knob position
function updateKnobPosition() {
  // Calculate the translation in pixels based on the width of the product slider container
  const containerWidth = productSliderContainer.offsetWidth;
  const knobWidth = knobElement.offsetWidth;
  const maxTranslation = containerWidth - knobWidth;
  const trackWidth = trackElement.offsetWidth;
  const scrollable =
    productSliderContainer.scrollWidth - productSliderContainer.clientWidth;
  const translation =
    scrollable > 0
      ? (productSliderContainer.scrollLeft / scrollable) * maxTranslation
      : 0;

  // Constrain translation to stay within the bounds of the track
  const constrainedTranslation = Math.min(
    Math.max(0, translation),
    trackWidth - knobWidth,
  );

  // translate3d promotes the knob to its own compositor layer on iOS.
  knobElement.style.transform = `translate3d(${constrainedTranslation}px, 0, 0)`;
}

function scheduleKnobUpdate() {
  if (knobRafId !== null) return;
  knobRafId = requestAnimationFrame(function () {
    knobRafId = null;
    updateKnobPosition();
  });
}

// Call the function to update knob position initially
if (productSliderContainer) {
  updateKnobPosition();
}

// Add event listener for scroll event
if (productSliderContainer) {
  productSliderContainer.addEventListener("scroll", scheduleKnobUpdate, {
    passive: true,
  });
}

$(document).ready(function () {
  // Feature slider pdp

  $(".feature_slider_row").slick({
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  //ticking machine
  var percentTime;
  var tick;
  var time = 1;
  var progressBarIndex = 0;

  $(".progressBarContainer .progressBar").each(function (index) {
    var progress = "<div class='inProgress inProgress" + index + "'></div>";
    $(this).html(progress);
  });

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    tick = setInterval(interval, 10);
  }

  function interval() {
    if (
      $(
        '.feature_slider_row .slick-track div[data-slick-index="' +
          progressBarIndex +
          '"]',
      ).attr("aria-hidden") === "true"
    ) {
      progressBarIndex = $(
        '.feature_slider_row .slick-track div[aria-hidden="false"]',
      ).data("slickIndex");
      startProgressbar();
    } else {
      percentTime += 1 / (time + 5);
      $(".inProgress" + progressBarIndex).css({
        width: percentTime + "%",
      });
      if (percentTime >= 100) {
        $(".single-item").slick("slickNext");
        progressBarIndex++;
        if (progressBarIndex > 2) {
          progressBarIndex = 0;
        }
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $(".inProgress").css({
      width: 0 + "%",
    });
    clearInterval(tick);
  }
  startProgressbar();
  // End ticking machine

  $(".progressBarContainer div").click(function () {
    clearInterval(tick);
    var goToThisIndex = $(this).find("span").data("slickIndex");
    $(".single-item").slick("slickGoTo", goToThisIndex, false);
    startProgressbar();
  });

  $(".feature_slider_row").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $(".current-slide").text((nextSlide + 1).toString().padStart(2, "0")); // Update current slide number
    },
  );
  $(".next-slide").click(function () {
    $(".feature_slider_row").slick("slickNext");
  });

  // Previous slide button click event
  $(".prev-slide").click(function () {
    $(".feature_slider_row").slick("slickPrev");
  });
  // Feature slider pdp end
  if (document.querySelectorAll(".size_variants_grid_wrap ul li")) {
    document
      .querySelectorAll(".size_variants_grid_wrap ul li")
      .forEach((li) => {
        li.addEventListener("click", function () {
          // Remove the class 'custom-active' from all list items
          document
            .querySelectorAll(".size_variants_grid_wrap ul li")
            .forEach((item) => {
              item.classList.remove("custom-active");
            });
          // Add the class 'custom-active' to the clicked list item
          this.classList.add("custom-active");
        });
      });
  }
  $(".giveaway-blog-row").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// toggel class for accordion
$(document).ready(function () {
  $(".product-new-accrodian-nav .content").hide();
  $(".product-new-accrodian-nav .set > a").on("click", function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
      $(this).next(".content").slideUp(300);
    } else {
      // Close all accordions
      $(".product-new-accrodian-nav .set > a")
        .removeClass("active")
        .find("i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(".product-new-accrodian-nav .content").slideUp(300);
      // Open current accordion
      $(this).addClass("active");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(this).next(".content").slideDown(300);
    }
  });
});

// 3D MODEL view
class Modal {
  constructor() {
    this.initModal();
  }

  initModal() {
    this.modal = document.createElement("div");
    this.modal.id = "iframeModal";
    this.modal.style.display = "none";
    this.modal.style.position = "fixed";
    this.modal.style.top = "0";
    this.modal.style.left = "0";
    this.modal.style.right = "0";
    this.modal.style.bottom = "0";
    this.modal.style.background = "rgba(0, 0, 0, 0.3)";
    this.modal.style.zIndex = "9999";
    this.modal.style.alignItems = "center";
    this.modal.style.justifyContent = "center";

    const content = document.createElement("div");
    content.className = "modal-content";
    content.style.width = window.innerWidth <= 768 ? "100%" : "70%";
    content.style.height = window.innerWidth <= 768 ? "100%" : "80%";
    content.style.background = "#fff";
    content.style.position = "relative";

    this.iframe = document.createElement("iframe");
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.iframe.style.border = "0";

    content.appendChild(this.iframe);

    const closeButton = document.createElement("div");
    closeButton.className = "modal-close";
    closeButton.style.cursor = "pointer";
    closeButton.style.position = "absolute";
    closeButton.style.top = "24px";
    closeButton.style.right = "24px";
    closeButton.style.zIndex = "10";

    closeButton.innerHTML = `
      <svg class="close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M16 0.96L15.06 0.02L8.00667 7.06L0.94 0L0 0.933333L7.06667 8L0 15.0667L0.946667 16L8.00667 8.94667L15.06 15.9867L16 15.0533L8.95333 8L16 0.96Z"
          fill="black"/>
      </svg>
    `;

    closeButton.addEventListener("click", () => this.closeModal());

    content.appendChild(closeButton);
    this.modal.appendChild(content);

    document.body.appendChild(this.modal);
  }

  openModal(url) {
    if (!url) return;

    this.iframe.src = url;
    this.modal.style.display = "flex";
  }

  closeModal() {
    this.modal.style.display = "none";
    this.iframe.src = "";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const modal = new Modal();

  const carouselButton = document.querySelector(".custom-carousel-button");

  if (carouselButton) {
    carouselButton.addEventListener("click", function () {
      const iframeSrc = this.getAttribute("data-iframe-src");

      if (iframeSrc) {
        modal.openModal(iframeSrc);
      } else {
        console.warn("data-iframe-src attribute not found.");
      }
    });
  } else {
  }

  // Hide engrave button if custom button doesn't exist
  if (!document.querySelector(".tte.cstm_btn")) {
    const secondDiv = document.querySelector(".product__media .engrave");

    if (secondDiv) {
      secondDiv.style.display = "none";
    }
  }
});

// CODE FOR SINGLE PRODUCT PAGE SIZE OPTION
$("#size_product").change(function () {
  window.location = $(this).val();
});
// END CODE HERE

//   PDP page images scroll on mobile
let ulElement = document.querySelector(".product__media-list");
let liElements = document.querySelectorAll(
  ".product__media-list li[data-index]",
);
let sliderInterval = setInterval(function () {
  if (liElements.length > 0) {
    clearInterval(sliderInterval);
  } else {
    ulElement = document.querySelector(".product__media-list");
    liElements = document.querySelectorAll(
      ".product__media-list li[data-index]",
    );
  }
}, 500);

document.addEventListener("DOMContentLoaded", function () {
  let ulElement = document.querySelector(".product__media-list");
  let liElements = document.querySelectorAll(
    ".product__media-list li[data-index]",
  );
  function getCurrentItem() {
    var scrollOffset = ulElement.scrollLeft;

    var containerRect = ulElement.getBoundingClientRect();
    var containerWidth = containerRect.width;
    var currentItem = null;
    for (var i = 0; i < liElements.length; i++) {
      var itemRect = liElements[i].getBoundingClientRect();
      var itemOffset = itemRect.left - containerRect.left;

      if (
        scrollOffset >= itemOffset &&
        scrollOffset < itemOffset + itemRect.width
      ) {
        currentItem = i;
        break;
      }
      if (
        scrollOffset >=
        containerWidth - containerRect.left - containerRect.width
      ) {
        currentItem = liElements.length;
      }
    }

    if (currentItem != null) {
      var transformCustom = currentItem * 100;
      if (currentItem < 2) {
        var chh = transformCustom;
      } else {
        var chh = parseInt(transformCustom - 100);
      }
      var transformCustom = currentItem * 100;
      // On iOS the smooth rAF-driven updater above owns the knob position;
      // writing a snapped %-based transform here as well causes the knob to
      // jitter between the two values during momentum scroll.
      if (!document.documentElement.classList.contains("is-ios")) {
        $(".mds-mini-slider__knob").css(
          "transform",
          "translateX(" + chh + "%" + ")",
        );
      }
    }
  }
  if (ulElement) {
    ulElement.addEventListener("scroll", getCurrentItem);
    getCurrentItem(); // Get current item on initial load
  }
});

$(document).ready(function () {
  var navElement = document.querySelector(".product__media-list");
  function pdpSlider() {
    $(".pdp-mobile-dot-nav .nav-yactive").click(function () {
      var data_index = $(this).attr("data-index");
      swiperCount = data_index;
      var screenSize = $(window).width();
      navElement.scrollLeft = 0;
      navElement.scrollLeft = screenSize * data_index;
      $(".pdp-mobile-dot-nav .nav-yactive").removeClass("active");
      $(this).addClass("active");
    });
  }

  pdpSlider();
  $(".color-swatch-wrap").click(function () {
    pdpSlider();
    navElement.scrollLeft = 0;
    swiperCount = 0;
  });
});


document.addEventListener("DOMContentLoaded", function () {

    function updateFooterGradient(variantId) {
        if (!window.footerGradientColors) return;

        const colors = window.footerGradientColors[variantId];

        if (colors && colors.length) {
            document.documentElement.style.setProperty(
                "--footer-light-color",
                colors[0]
            );
        }
    }

    document.addEventListener("variant:change", function (event) {
        if (event.detail && event.detail.variant) {
            updateFooterGradient(event.detail.variant.id);
        }
    });

});